<template>
  <div class="container">
    <span class="title is-3">{{ empresa.nombrec }}</span>
    <small class="title is-5"
      >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
    >
    <small class="subtitle is-7">{{ empresa.nombre }}</small>
    <hr />
    <h1 class="title">Cierre de cuentas</h1>
    <y-periodselector
      @period="periodselected"
      :iscierre="true"
      :period="period"
    ></y-periodselector>
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="field">
          <label class="label">Seleccione el comprobante de cierre</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="query.comprobante">
                <option value="null">Seleccione Comprobante</option>
                <option
                  v-for="(item, index) in comprobantes"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.codigo }} - {{ item.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="field">
          <label class="label">Seleccione la cuenta que desea cerrar</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="query.cuenta">
                <option value="null">Seleccione Cuenta</option>
                <option
                  v-for="(item, index) in cuentas"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.codigo }} - {{ item.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Seleccione la cuenta de cierre</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="query.contrapartida">
                <option value="null">Seleccione Cuenta</option>
                <option
                  v-for="(item, index) in cuentas"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.codigo }} - {{ item.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Tercero de cierre</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="query.tercero">
                <option value="null">Seleccione el tercero</option>
                <option
                  v-for="(item, index) in nits"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.codigo }} - {{ item.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">Número de documento</label>
          <div class="control">
            <input
              v-model="query.documento"
              class="input"
              type="text"
              placeholder="Documento"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <button class="button is-link" @click="cierre">Cerrar cuenta</button>
        <button class="button is-dark" @click="cierreyeardeshacer">
          Deshacer todos los cierres del mes
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
export default {
  data() {
    return {
      period: {
        year: null,
        months: null,
      },
      title: "Documentos",
      comprobantes: [],
      cuentasp: [],
      cuantasd: [],
      query: {
        comprobante: null,
        cuenta: null,
        documento: null,
        year: null,
        mes: null,
        contrapartida: null,
        tercero: null,
      },
    };
  },
  computed: {
    ...mapState(["empresa", "cuentas", "nits"]),
  },
  methods: {
    async cierre() {
      try {
        if (!this.query.comprobante) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un comprobante",
            type: "is-warning",
            position: "top-center",
            duration: 4000,
          });
          return false;
        }
        if (!this.query.cuenta) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar la cuenta que quiere cerrar",
            type: "is-warning",
            position: "top-center",
            duration: 4000,
          });
          return false;
        }
        if (!this.query.contrapartida) {
          this.$store.dispatch("notify", {
            message:
              "Debe seleccionar la cuenta contra la que cerrará los registros",
            type: "is-warning",
            position: "top-center",
            duration: 4000,
          });
          return false;
        }
        if (!this.query.tercero) {
          this.$store.dispatch("notify", {
            message:
              "Debe seleccionar el tercero que se utilizara en la contrapartida",
            type: "is-warning",
            position: "top-center",
            duration: 4000,
          });
          return false;
        }
        if (!this.query.documento) {
          this.$store.dispatch("notify", {
            message: "Debe indicar un número de documento",
            type: "is-warning",
            position: "top-center",
            duration: 4000,
          });
          return false;
        }
        this.query.year = this.period.year;
        this.query.mes = this.period.months[0];
        const result = await apiServices.post(`/cierrecuenta`, {
          cierre: this.query,
        });
        if (result.data) {
          if (result.data.message) {
            this.$store.dispatch("notify", {
              message: result.data.message,
              type: "is-danger",
              position: "top-center",
              duration: 4000,
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findComprobantes() {
      try {
        const result = await apiServices.get(`/comprobantes`);
        this.comprobantes = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
    async cierreyeardeshacer() {
      try {
        const result = await apiServices.post(`/cierreyeardeshacer`, {
          year: this.period.year,
          mes: this.period.months[0],
        });
        if (result.data) {
          this.$store.dispatch("notify", {
            message: result.data.message,
            type: "is-info",
            position: "top-center",
            duration: 4000,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    cuentasPatrimonio() {
      this.cuentasp = [];
      this.cuentasp.push();
      this.cuentasp = this.cuentas.filter(function (k) {
        if (k.codigo.substr(0, 1) === "3") {
          return k;
        }
      });
    },
    periodselected(period) {
      this.period = period;
    },
  },
  created() {
    this.findComprobantes();
    this.cuentasPatrimonio();
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
    this.cuentas.sort(function (a, b) {
      if (a.codigo < b.codigo) {
        return -1;
      }
      if (a.codigo > b.codigo) {
        return 1;
      }
      return 0;
    });
    this.nits.sort(function (a, b) {
      if (a.nombre < b.nombre) {
        return -1;
      }
      if (a.nombre > b.nombre) {
        return 1;
      }
      return 0;
    });
  },
  components: {
    yPeriodselector,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cierre/cuenta/Cierrecuenta.vue